import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import * as React from 'react';

import { RatioInfoList, RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import * as keyset from './AddBillboardFormatsRecommendationCard.i18n';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

export interface AddBillboardFormatsRecommendationCardProps {
    character: RecommendationCharacter;
    ratioInfoList?: Array<RatioInfoList>;
    view: RecommendationCardView;
    onClose?: () => void;
    title?: string;
    titleHint?: string;
    type: RecommendationType;
}

export const AddBillboardFormatsRecommendationCard = React.memo(
    (props: AddBillboardFormatsRecommendationCardProps): JSX.Element | null => {
        const { view, character, ratioInfoList, title, titleHint, type } = props;

        if (!ratioInfoList || !ratioInfoList.length) {
            return null;
        }

        const titleRecommendation = title || getTitle(view);
        const titleHintRecommendation = titleHint || getTitleHint(view);

        return (
            <RecommendationCard
                type={type}
                view={view}
                icon={Shape2Icon.lamp}
                character={character}
                title={titleRecommendation}
                titleHint={titleHintRecommendation}
                isInProgress={false}
            >
                {i18nRaw('add-placements', {
                    formats: getRatioInfo(ratioInfoList.slice(0, 5)),
                    count: ratioInfoList.length
                })}
            </RecommendationCard>
        );
    }
);

const getTitle = (view: RecommendationCardView): string | undefined => {
    switch (view) {
        case RecommendationCardView.recommendationsPopup:
            return i18n('title');

        default:
            return;
    }
};

const getTitleHint = (view: RecommendationCardView): string | undefined => {
    switch (view) {
        case RecommendationCardView.recommendationsPopup:
            return i18n('title-hint');

        default:
            return;
    }
};

const getRatioInfo = (ratioInfoList: Array<RatioInfoList>) => {
    return ratioInfoList.map((ratioInfo, index) => {
        if (!ratioInfo) {
            return;
        }
        const isNotLastItem = index !== ratioInfoList.length - 1;

        return (
            <span key={index}>
                {getFormat(ratioInfo)}
                {isNotLastItem && ', '}
            </span>
        );
    });
};

const getFormat = (ratioInfo: RatioInfoList) => {
    return i18nRaw('ratio-info', {
        format: (
            <b>
                {i18n('video-format', {
                    width: ratioInfo.videoFormat.width,
                    height: ratioInfo.videoFormat.height,
                    duration: ratioInfo.videoFormat.duration
                })}
            </b>
        ),
        count: ratioInfo.creativesCount
    });
};
